export default __webpack_public_path__ + "static/media/vg-text.21c38b64.png";